export var TicketPriority;
(function (TicketPriority) {
    TicketPriority[TicketPriority["LOW"] = 10] = "LOW";
    TicketPriority[TicketPriority["NORMAL"] = 20] = "NORMAL";
    TicketPriority[TicketPriority["HIGH"] = 30] = "HIGH";
})(TicketPriority || (TicketPriority = {}));
;
//# sourceMappingURL=ticket-priority.enum.js.map